import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import { ACCESS_TOKEN } from '@/store/mutation-types'
import ls from '@/utils/Storage'
import { setDocumentTitle } from '@/utils/domUtil'
import type { Router } from 'vue-router'
import { notification, message } from 'ant-design-vue'
import { useLogin } from '@/store/login'
import { transformRoutes, extractButtonCodeNos } from '@/utils/resetTreeMenu'
import { clearUserInfo } from '@/utils/util'
import generateAsyncRoutes from './generateAsyncRoutes'
import { example } from './exampleRouterMap'
import { businessRoutesState, ensureBusinessRoutesAccount, resetBusinessRoutes } from './businessRoutes'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'loginIndex', 'register', 'registerResult'] // 不进行拦截的路由名称集合
const defaultRoutePath = '/'

export const setupBeforeEach = (router: Router) => {
  router.beforeEach(async (to, from, next) => {
    NProgress.start() // 加载进度条
    setDocumentTitle(to)
    const accessToken = ls.get(ACCESS_TOKEN)
    if (accessToken) {
      ensureBusinessRoutesAccount(router, accessToken)
      const loginApi = useLogin()
      await loginApi.getUserInfo()
      const { treeMenu, roleType } = loginApi.userInfos as any
      if (!businessRoutesState.hasAdded) {
        if (roleType === 'admin') {
          router.addRoute(example as any)
          businessRoutesState.hasAdded = true
          businessRoutesState.accessToken = accessToken
          if (to.path === '/') {
            next({
              path: example.redirect as string,
              replace: true
            })
          } else {
            next({
              path: to.path,
              query: to.query,
              hash: to.hash,
              replace: true
            })
          }
          return
        }
        const menu = await transformRoutes(treeMenu)
        const buttonCodeNos = extractButtonCodeNos(treeMenu)
        loginApi.setAuthBtnList(buttonCodeNos)
        const homePath = await generateAsyncRoutes(router, menu)
        const hasHomePath = Array.isArray(homePath) ? homePath.length > 0 : Boolean(homePath)
        if (hasHomePath) {
          businessRoutesState.hasAdded = true
          businessRoutesState.accessToken = accessToken
          if (to.path === '/') {
            next({
              path: homePath,
              replace: true
            })
          } else {
            next({
              path: to.path,
              query: to.query,
              hash: to.hash,
              replace: true
            })
          }
        } else {
          message.error('暂无权限，请联系管理员')
          clearUserInfo()
          resetBusinessRoutes(router)
          loginApi.$reset()
          next({ name: 'login', replace: true })
        }
        return
      }

      /* has token */
      if (to.name === 'login') {
        next({ path: defaultRoutePath })
        NProgress.done()
      } else {
        next()
      }
    } else {
      if (whiteList.includes(to.name as any)) {
        // 在免登录白名单，直接进入
        next()
      } else {
        next({ name: 'login', query: { redirect: to.fullPath } })
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  })

  // 路由懒加载失败时的提示
  router.onError((error) => {
    if (window.env === 'localhost') {
      notification.error({
        message: 'Dynamic import error',
        description: error.stack
      })
    } else {
      router.push({ name: 'error', params: { errorMsg: error.stack } })
    }
  })
}

export const setupAfterEach = (router: Router) => {
  router.afterEach(() => {
    NProgress.done() // finish progress bar
  })
}
